export const NAME = "taskName";
export const CATEGORY = "taskCategory";
export const PRIORITY = "priority";
export const TERM = "taskTerm";
export const COMMENTS = "taskDescription";
